import { useCallback, useState } from 'react';
import { alertSrc } from '#shared/assets';
import { useConfirm } from '#shared/lib/hooks';
import { showError, showSuccess } from '#shared/lib/toast';
import { cancelWarehouseDeliveryIntake, type CancelWarehouseDeliveryIntakeParams } from '../../api/warehouseIntakes';

interface UseWarehouseIntakeCancelParams extends CancelWarehouseDeliveryIntakeParams {
    showConfirm?: boolean;
}

export const useWarehouseIntakeCancel = (params: UseWarehouseIntakeCancelParams) => {
    const { showConfirm, ...requestParams } = params;

    const [isLoading, setIsLoading] = useState(false);

    const { confirm, renderConfirmModal } = useConfirm();

    const cancelWarehouseIntake = useCallback(async () => {
        if (isLoading) {
            return;
        }

        try {
            setIsLoading(true);

            if (showConfirm) {
                const isConfirmed = await confirm({
                    title: 'Отменить заборку?',
                    applyText: 'Да, отменить',
                    bodyText: 'После отмены всем заказам из этой заборки нужно назначить новую заборку',
                    imageSrc: alertSrc,
                });

                if (!isConfirmed) {
                    return;
                }
            }

            await cancelWarehouseDeliveryIntake(requestParams);

            showSuccess('Заборка отменена');
        } catch (error) {
            showError({ label: 'Не удалось отменить заборку' }, error);
        } finally {
            setIsLoading(false);
        }
    }, [confirm, isLoading, requestParams, showConfirm]);

    return {
        renderConfirmModal,
        cancelWarehouseIntake,
        isCancellingWarehouseIntake: isLoading,
    };
};
